import type { CustomerBank } from "../../../../common/types/customerBank";
import { BaseService } from "./baseService";
import httpRequest from "./index";

export class BankService extends BaseService<any, any, any, any> {
    // 根据 id 查询
    async getBankById(id: string | number): Promise<CustomerBank> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    // 修改客户银行账号
    async updateBank(id: number, banks: CustomerBank): Promise<any> {
        const { data } = await this.service.put(`${this.path}/${id}`, banks);
        return data;
    }

    // 删除客户银行账号
    async deleteBank(id: string | number): Promise<any> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    // 新增客户银行账号
    async createBank(banks: CustomerBank): Promise<any> {
        const { data } = await this.service.post(`${this.path}`, banks);
        return data;
    }

    // 查询客户银行账号列表
    async getBankList(): Promise<CustomerBank[]> {
        const { data } = await this.service.get(`${this.path}/findByCustomerId`);
        return data as Promise<CustomerBank[]>;
    }
}

export const bankService = new BankService("/customer/bank", httpRequest);
